import * as React from "react";

// translate
import {t} from "i18next";

// components
import {Dialog} from "../../../components/Dialogs/Dialog";
import {Table} from "semantic-ui-react";
import {Button} from "../../../components/Button";
import SelectField from "../../../components/SelectField";

// dtos
import {WorkflowDtoType, OptionBasicDtoOptionType} from "../../../services/Client";

interface IWorkflowAddDialogProps {
    open: boolean;
    workflowTypes: WorkflowDtoType[];
    optionTypes: OptionBasicDtoOptionType[];
    typefamilies: String[];
    requestClose: () => void;
    onCreateNewWorkflow: (workflowType: WorkflowDtoType, optionTypes: OptionBasicDtoOptionType[] | undefined, typefamilies: String[] | undefined) => void;
}

interface IWorkflowAddDialogState {
    selectedWorkflowType: WorkflowDtoType;
    selectedOptionTypes?: OptionBasicDtoOptionType[];
    selectedTypefamilies?: String[];
}

export class WorkflowAddDialog extends React.Component<IWorkflowAddDialogProps, IWorkflowAddDialogState> {

    constructor(props: IWorkflowAddDialogProps) {
        super(props);
        this.state = {
            selectedWorkflowType: WorkflowDtoType.OPTION_PARTITION
        };
    }

    componentDidUpdate(prevProps: IWorkflowAddDialogProps) {
        if (prevProps.open !== this.props.open) {
            this.setState({
                selectedWorkflowType: WorkflowDtoType.OPTION_PARTITION,
                selectedOptionTypes: undefined,
                selectedTypefamilies: undefined
            });
        }
      }

    private workflowTypeSelectionChanged(value: WorkflowDtoType): void {
        this.setState({selectedWorkflowType: value});
    }

    private optionTypeSelectionChanged(values: OptionBasicDtoOptionType[]): void {
        this.setState({selectedOptionTypes: values});
    }

    private typefamilySelectionChanged(values: String[]): void {
        // Replace 'M_TYPEFAMILY' with 'M' in the values array
        const updatedValues = values.map((value) => (value === 'M_TYPEFAMILY' ? 'M' : value));
        this.setState({selectedTypefamilies: updatedValues});
    }

    render() {
        const {
            workflowTypes,
            optionTypes,
            typefamilies
        } = this.props;
        const actions: JSX.Element[] = [
            (
                <Button
                    key={"confirmButton"}
                    icon={"checkmark"}
                    onClick={() => this.props.onCreateNewWorkflow(this.state.selectedWorkflowType, this.state.selectedOptionTypes, this.state.selectedTypefamilies)}
                />
            ),
            (
                <Button
                    key={"cancelButton"}
                    icon={"cancel"}
                    onClick={this.props.requestClose}
                />
            )
        ];

        return (
            <Dialog
                open={this.props.open}
                title={t("WORKFLOW:NEW_WORKFLOW")}
                actions={actions}
            >
                <Table definition={true}>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell className={"bold width--30Percent"}>
                                {t("WORKFLOW:WORKFLOW_TYPE")}
                            </Table.Cell>
                            <Table.Cell>
                                <SelectField
                                    value={this.state.selectedWorkflowType}
                                    dataSource={workflowTypes}
                                    clearable={false}
                                    searchable={false}
                                    onChange={(workflowType: WorkflowDtoType) => this.workflowTypeSelectionChanged(workflowType)}
                                />
                            </Table.Cell>
                        </Table.Row>
                        {this.state.selectedWorkflowType !== WorkflowDtoType.KUMA && <Table.Row>
                            <Table.Cell className={"bold width--30Percent"}>
                                {t("WORKFLOW:OPTION_TYPES")}
                            </Table.Cell>
                            <Table.Cell>
                                <SelectField
                                    value={this.state.selectedOptionTypes}
                                    dataSource={optionTypes}
                                    multi={true}
                                    searchable={true}
                                    rendererKey={(value: OptionBasicDtoOptionType) => t("GLOBAL:" + value) + " (" + value + ')'}
                                    onChange={(values: any[]) =>
                                        this.optionTypeSelectionChanged((values.map((v) => v.selectedValue) as OptionBasicDtoOptionType[]))
                                    }
                                />
                            </Table.Cell>
                        </Table.Row>}
                        {this.state.selectedWorkflowType !== WorkflowDtoType.KUMA && <Table.Row>
                            <Table.Cell className={"bold width--30Percent"}>
                                {t("WORKFLOW:TYPE_FAMILIES")}
                            </Table.Cell>
                            <Table.Cell>
                                <SelectField
                                    value={this.state.selectedTypefamilies}
                                    dataSource={typefamilies}
                                    multi={true}
                                    searchable={true}
                                    rendererKey={(value: String) => {
                                        if (value === 'M') {
                                            return t("GLOBAL:M_TYPEFAMILY");
                                        }
                                        return t("GLOBAL:" + value);
                                    }}
                                    onChange={(values: any[]) =>
                                        this.typefamilySelectionChanged((values.map((v) => v.selectedValue) as String[]))
                                    }
                                />
                            </Table.Cell>
                        </Table.Row>}
                    </Table.Body>
                </Table>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/AdminView/WorkflowTab/WorkflowAddDialog.tsx